<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="close"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="name"
                v-model="editedItem.name"
                label="Queue name"
                dense
                hide-details
                :rules="[
                  rules.rulesCharcacters50.required,
                  rules.rulesCharcacters50.min,
                  rules.rulesCharcacters50.max
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-select
                id="type"
                class="box-select"
                item-text="label"
                item-value="value"
                v-model="editedItem.type"
                :items="types"
                label="Queue type"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                id="status"
                v-model="editedItem.status"
                :label="editedItem.status ? 'Active' : 'Inactive'"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" @click="close"
          >Cancel</v-btn
        >
        <v-btn id="btn-ok" class="btn-primary" @click="save">{{
          btnSave
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogManageQueues',
  props: {
    viewType: String,
    rules: Object,
    dialog: Boolean,
    editedIndex: Number,
    editedItem: Object,
    errorMessage: String
  },
  data() {
    return {
      types: []
    }
  },
  created() {
    if (this.viewAll() || this.viewVoice()) {
      this.types.push({ label: 'Voice', value: 'voice' })
      if (!this.editedItem.type) this.editedItem.type = 'voice'
    }
    if (this.viewAll() || this.viewChat()) {
      this.types.push({ label: 'Chat', value: 'chat' })
    }
    if (!this.editedItem.type) this.editedItem.type = 'chat'
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New queue' : 'Edit queue'
    },
    btnSave() {
      return this.editedIndex === -1 ? 'Add' : 'Save'
    }
  },
  methods: {
    viewVoice() {
      return this.viewType === 'voice'
    },
    viewChat() {
      return this.viewType === 'chat'
    },
    viewAll() {
      return this.viewType === 'all'
    },
    close() {
      this.$emit('close', null)
    },
    save() {
      this.$emit('save', null)
    }
  }
}
</script>
